export default __webpack_public_path__ + "static/community_card-a05b9b68049f04ba60bdb085ee1816ea.png";